import BaseController from "niteroi/packages/system/controllers/Base.controller";
import {GenericTile$PressEvent} from "sap/m/GenericTile";

/**
 * @namespace niteroi.packages.system.controller
 */
export default class Main extends BaseController {

    public onInit(): void {
        super.onInit();
        const launchpadModel = this.createRequestModel();
        launchpadModel.loadData("/api/launchpad", {}, true).then(() => {
            this.getModel("session").setProperty("/launchpad/services", launchpadModel.getProperty("/services"));
        });
    }

    public handlePressLaunchpadTile(event: GenericTile$PressEvent): void {
        const source = event.getSource();
        const bindingContext = source.getBindingContext("session");
        const service = bindingContext.getModel().getProperty(bindingContext.getPath()) as { url: string };

        this.navTo(service.url, {}, false);
    }

    public onPressButtonProfile(): void {
        const userId = this.getModel("session").getProperty("/user/userId") as string;
        if (userId) {
            this.navTo("system/users/edit", { "id": userId}, false);
        }
    }

    public onPressButtonSessions(): void {
        this.navTo("system/sessions", {}, false);
    }
}
